function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M224 512c35 0 64-29 64-64H160c0 35 29 64 64 64zm215-150c-19-20-55-52-55-154 0-78-54-140-128-155V32c0-18-14-32-32-32s-32 14-32 32v21C118 68 64 130 64 208c0 102-36 134-55 154-6 7-9 15-9 22 0 16 13 32 32 32h384c19 0 32-16 32-32 0-7-3-15-9-22z"
});

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _ref);
}

export default SvgBell;